import MainMobile from "./MainMobile";

export default MainMobile;
export { MainMobile };
